import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useGetAppConfigQuery } from 'shared/api';
import { EYmEvents, EYmEventsO1 } from 'shared/typings';
import { sendYmEvent } from 'shared/utils/ym/sendYmEvent';

export const useSendPageViewEvent = () => {
	const { pathname } = useLocation();
	const { data: appConfig } = useGetAppConfigQuery();

	useEffect(() => {
		if (appConfig?.user?.user_id) {
			sendYmEvent({ event: EYmEvents.PAGE_VIEW, o1: EYmEventsO1.ACCOUNT });
		}
	}, [pathname, appConfig?.user?.user_id]);
};
